import { Link } from 'react-router-dom';
import MarketingFooter from '../components/MarketingFooter';
import MarketingNav from '../components/MarketingNav';

export default function StoryPage() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-how-paper-soft text-how-space-deep">
      <section className="relative min-h-screen overflow-hidden">
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-[52%] bg-gradient-to-b from-transparent to-how-rose opacity-70"
          aria-hidden="true"
        />

        <MarketingNav actionLabel="Sign up" actionTo="/signup" isStoryPage />

        <main className="relative z-10 mx-auto flex min-h-[calc(100svh-104px)] w-full max-w-6xl items-center px-6 py-16 sm:px-10 lg:py-24">
          <div className="grid w-full gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 xl:gap-28">
            <header className="lg:pt-2">
              <p className="mb-5 text-xs uppercase tracking-[0.14em] text-how-space-mid">
                The philosophy behind Howie
              </p>
              <h1 className="marketing-display-heading marketing-story-heading text-how-space-deep">
                <span className="block">How</span>{' '}
                <span className="block">matters.</span>
              </h1>
              <div className="mt-8 h-1 w-16 rounded-full bg-how-accent-warm" aria-hidden="true" />
            </header>

            <div className="space-y-7 font-voice text-xl leading-[1.55] tracking-[-0.02em] text-how-space-mid sm:text-2xl sm:leading-[1.55]">
              <p className="text-[1.35em] leading-[1.42] text-how-space-deep">
                How you disagree, keep a promise, or admit a mistake shapes whether people trust you. Technology carries the consequences further.
              </p>
              <figure className="-mx-2 py-2 sm:-mx-6 lg:mx-0">
                <img
                  src="/runner.png"
                  alt=""
                  className="w-full rounded-[24px] object-cover shadow-figure sm:rounded-[32px]"
                />
              </figure>
              <p>
                Philosopher Dov Seidman calls this the HOW: the values you put into action, especially under pressure. His conviction: “HOW we do anything means everything.”
              </p>
              <p>
                Howie helps you build a HOW practice. Grounded in Dov’s philosophy, this AI companion asks questions that help you examine your assumptions, weigh your responsibilities, and choose your next move.
              </p>
              <p>
                Bring the conversation you’re avoiding. The decision you’re weighing. The moment you wish you could take back.
              </p>
              <p>Practice begins there.</p>
              <div className="pt-2">
                <Link
                  to="/signup"
                  className="inline-flex rounded-full bg-how-space-deep px-7 py-3 font-body text-base leading-6 text-how-paper-soft transition-colors hover:bg-how-space-mid focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-how-space-deep focus-visible:ring-offset-4"
                >
                  Get started
                </Link>
              </div>
            </div>
          </div>
        </main>
      </section>

      <div className="bg-how-paper-soft text-how-space-deep">
        <MarketingFooter />
      </div>
    </div>
  );
}
